/* istanbul ignore file */
export { default } from './CarouselVehicle';
